module.exports = __webpack_public_path__ + "static/media/backgroundMap@2x.914bbd93.jpg";